import { Injectable } from '@angular/core';
import { PurecloudService } from '../purecloud/purecloud.service';
import * as platformClient from 'purecloud-platform-client-v2';

class getRoutingQueuesOptions implements platformClient.RoutingApi.getRoutingQueuesOptions {
  constructor(public pageSize: number, public pageNumber: number) {
  }
}

@Injectable({
  providedIn: 'root'
})
export class AbandonedInteractionsDetailCloudService {

  constructor(private purecloudService : PurecloudService) { }

  public getCampaigns(): Promise<any|Array<any>> {
    return this.purecloudService.checkLogin() || new Promise<Array<any>>((resolve, reject) => {
      this.getCampaignsInternal(new getRoutingQueuesOptions(100, 1), new Array<any>(), resolve, reject);
    });
  }
  private getCampaignsInternal(opts: getRoutingQueuesOptions, users: Array<any>, resolve, reject) {
    this.purecloudService.getRouting().getRoutingQueues()
      .then((response) => this.thenCampaigns(response, users, resolve, reject))
      .catch((response) => this.catchCampaigns(response, reject));
  }
  private thenCampaigns(response: platformClient.Models.QueueEntityListing, users: Array<any>, resolve, reject) {
    response.entities.forEach((user) => users.push({
      id: user.id,
      name: user.name
    }));
    if(response.pageNumber < response.pageCount) {
      this.getCampaignsInternal(new getRoutingQueuesOptions(100, (response.pageNumber + 1)), users, resolve, reject);
    } else {
      resolve(users);
    }
  }
  private catchCampaigns(response: any, reject) {
    reject(response);
  }
}
